module.exports = __webpack_public_path__ + "src/img/galerie/innenrenovierung/Sauna-Vorher.jpg";